<article class="formEditor">
    <span class="formLabel">Department</span>
    <lib-generic-dropdown-multiselect
        [source]="items()"
        [selectedItems]="selectedItems()"
        (selectedItemsChange)="onSelectedItemsChange($event)"
        [config]="{
            defaultText: placeholderText(),
            itemDisplayKey: 'name'
        }"
        [placeholder]="placeholderText()"
        [isReadOnly]="isReadOnly()"
    >
    </lib-generic-dropdown-multiselect>
</article>
